import type { NewRelicConfig } from './newrelic.types';

/**
 * DEV New Relic Browser App (star-educator-report-shell-dev), account 8214284.
 * Values are the browser ingest key + IDs from the NR "Add data → Browser (NPM)"
 * snippet — public by design (ship in client JS). allowed_origins on the Browser
 * App restricts which domains may report.
 */
export const newRelicConfig: NewRelicConfig = {
  enabled: true,
  options: {
    info: {
      applicationID: '1120555112',
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRBR-a7c387cd96cb6739e62',
      sa: 1,
    },
    init: {
      ajax: { deny_list: ['bam.nr-data.net'] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true,
      },
      privacy: { cookies_enabled: true },
    },
    loader_config: {
      accountID: 8214284,
      agentID: 1120555112,
      applicationID: 1120555112,
      licenseKey: 'NRBR-a7c387cd96cb6739e62',
      trustKey: 2940311,
    },
  },
};
